import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser, getAuthorizedMenus } from "../../../redux";
import { removeToken } from "../../../utils/tokenHelper";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import styles from "./DashboardLayout.module.scss";

const DashboardLayout = ({ children, variant = "client", user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const notifications = [
    { id: 1, text: "New member registration", time: "5m ago" },
    { id: 2, text: "Payment received from John", time: "1h ago" },
  ];

  useEffect(() => {
    if (variant === "client") {
      dispatch(getAuthorizedMenus());
    }
  }, [dispatch, variant]);

  const getActiveItem = () => {
    const path = location.pathname;
    if (path.startsWith("/app/dashboard")) return "dashboard";
    if (path.startsWith("/app/clients")) return "clients";
    if (path.startsWith("/app/trainers")) return "trainers";
    if (path.startsWith("/app/programs")) return "programs";
    if (path.startsWith("/app/nutrition")) return "nutrition";
    if (path.startsWith("/app/sessions")) return "sessions";
    if (path.startsWith("/app/notifications")) return "notifications";
    if (path.startsWith("/app/payments")) return "payments";
    if (path.startsWith("/app/reports")) return "reports";
    if (path.startsWith("/app/post")) return "marketing-studio";
    if (path.startsWith("/admin/dashboard")) return "dashboard";
    return "";
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    removeToken();
    dispatch(logoutUser());
    navigate("/", { replace: true });
  };

  const handleSidebarToggle = (collapsed) => {
    setSidebarCollapsed(collapsed);
  };

  return (
    <div className={styles.layout}>
      <Sidebar
        variant={variant}
        activeItem={getActiveItem()}
        onNavigate={handleNavigate}
        businessType={user?.businessType}
        onToggle={handleSidebarToggle}
      />
      <div
        className={`${styles.main} ${sidebarCollapsed ? styles.sidebarCollapsed : ""}`}
      >
        <Navbar
          variant={variant}
          user={user}
          notifications={notifications}
          onLogout={handleLogout}
        />
        <main className={styles.content}>{children}</main>
      </div>
    </div>
  );
};

export default DashboardLayout;
